module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "copy-btn",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c10fcd4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/copy-btn/copy-btn.vue
// module id = 908
// module chunks = 1